import React from "react";
import LandingSection from "../../sections/HomeSections/LandingSection/LandingSection";
import ContractSection from "../../sections/HomeSections/ContractSection/ContractSection";
import JoinUsSection from "../../sections/HomeSections/JoinUsSection/JoinUsSection";
import AboutSection from "../../sections/HomeSections/AboutSection/AboutSection";
import HowToBuySection from "../../sections/HomeSections/HowToBuySection/HowToBuySection";
import JabanomicsSection from "../../sections/HomeSections/JabanomicsSection/JabanomicsSection";

const Homepage = () => {
  return (
    <div>
      <LandingSection />
      <AboutSection />
      <JabanomicsSection />
      <HowToBuySection />
      <ContractSection />
      <JoinUsSection />
    </div>
  );
};

export default Homepage;
